import IMG_9958 from './gallery/IMG_9958.JPG';
import IMG_9977 from './gallery/IMG_9977.JPG';
import IMG_9981 from './gallery/IMG_9981.jpg';
import IMG_9986 from './gallery/IMG_9986.JPG';
import IMG_9988 from './gallery/IMG_9988.JPG';

export const galleryImages = {
  IMG_9958,
  IMG_9977,
  IMG_9981,
  IMG_9986,
  IMG_9988,
}; 
